module.exports = __webpack_public_path__ + "img/4f_r_gindako.d8048f51.png";